module.exports = __webpack_public_path__ + "img/scene_bedtime_backlight@2x.c970c331.png";